import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFolderSparkle"><Path d="M10.5352 3L12.5352 6H22V20H7.92676L7.94727 19.9473L11 18.7734V15.2266L7.94727 14.0518L6.77344 11H3.22656L2.05176 14.0518L2 14.0713V3H10.5352Z" fill="currentColor"/><Path d="M2.05176 19.9473L2.07227 20H2V19.9268L2.05176 19.9473Z" fill="currentColor"/><Path d="M5.4 13H4.6L3.6 15.6L1 16.6V17.4L3.6 18.4L4.6 21H5.4L6.4 18.4L9 17.4V16.6L6.4 15.6L5.4 13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderSparkle;
